import { render } from "./sortable_header.vue?vue&type=template&id=f04b25c0"
import script from "./sortable_header.vue?vue&type=script&lang=js"
export * from "./sortable_header.vue?vue&type=script&lang=js"

import exportComponent from "/home/deployer/asset-portal/releases/20260828153143/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__